(function () {
  var ZODIACS = [
    { id: 'capricorn', name: 'Capricorn', nameCn: '摩羯座', symbol: '♑', dates: 'Dec 22 — Jan 19',
      sun: 'Core Self', sunMeta: 'Discipline & Ambition', moon: 'Emotional', moonMeta: 'Quiet Resolve',
      pillars: ['Structure', 'Patience', 'Legacy'] },
    { id: 'aquarius', name: 'Aquarius', nameCn: '水瓶座', symbol: '♒', dates: 'Jan 20 — Feb 18',
      sun: 'Core Self', sunMeta: 'Innovation & Freedom', moon: 'Emotional', moonMeta: 'Deep Reflection',
      pillars: ['Creativity', 'Communication', 'Flow State'] },
    { id: 'pisces', name: 'Pisces', nameCn: '双鱼座', symbol: '♓', dates: 'Feb 19 — Mar 20',
      sun: 'Core Self', sunMeta: 'Intuition & Compassion', moon: 'Emotional', moonMeta: 'Dreaming Depth',
      pillars: ['Imagination', 'Healing', 'Stillness'] },
    { id: 'aries', name: 'Aries', nameCn: '白羊座', symbol: '♈', dates: 'Mar 21 — Apr 19',
      sun: 'Core Self', sunMeta: 'Courage & Initiative', moon: 'Emotional', moonMeta: 'Passionate Pulse',
      pillars: ['Action', 'Confidence', 'New Starts'] },
    { id: 'taurus', name: 'Taurus', nameCn: '金牛座', symbol: '♉', dates: 'Apr 20 — May 20',
      sun: 'Core Self', sunMeta: 'Stability & Beauty', moon: 'Emotional', moonMeta: 'Sensual Calm',
      pillars: ['Grounding', 'Abundance', 'Comfort'] },
    { id: 'gemini', name: 'Gemini', nameCn: '双子座', symbol: '♊', dates: 'May 21 — Jun 20',
      sun: 'Core Self', sunMeta: 'Curiosity & Connection', moon: 'Emotional', moonMeta: 'Restless Mind',
      pillars: ['Dialogue', 'Learning', 'Adaptability'] },
    { id: 'cancer', name: 'Cancer', nameCn: '巨蟹座', symbol: '♋', dates: 'Jun 21 — Jul 22',
      sun: 'Core Self', sunMeta: 'Nurture & Protection', moon: 'Emotional', moonMeta: 'Tender Tide',
      pillars: ['Home', 'Trust', 'Inner Safety'] },
    { id: 'leo', name: 'Leo', nameCn: '狮子座', symbol: '♌', dates: 'Jul 23 — Aug 22',
      sun: 'Core Self', sunMeta: 'Radiance & Leadership', moon: 'Emotional', moonMeta: 'Warm Heart',
      pillars: ['Expression', 'Joy', 'Visibility'] },
    { id: 'virgo', name: 'Virgo', nameCn: '处女座', symbol: '♍', dates: 'Aug 23 — Sep 22',
      sun: 'Core Self', sunMeta: 'Precision & Service', moon: 'Emotional', moonMeta: 'Thoughtful Care',
      pillars: ['Clarity', 'Routine', 'Refinement'] },
    { id: 'libra', name: 'Libra', nameCn: '天秤座', symbol: '♎', dates: 'Sep 23 — Oct 22',
      sun: 'Core Self', sunMeta: 'Harmony & Balance', moon: 'Emotional', moonMeta: 'Graceful Feeling',
      pillars: ['Partnership', 'Beauty', 'Equilibrium'] },
    { id: 'scorpio', name: 'Scorpio', nameCn: '天蝎座', symbol: '♏', dates: 'Oct 23 — Nov 21',
      sun: 'Core Self', sunMeta: 'Depth & Transformation', moon: 'Emotional', moonMeta: 'Magnetic Intensity',
      pillars: ['Truth', 'Release', 'Renewal'] },
    { id: 'sagittarius', name: 'Sagittarius', nameCn: '射手座', symbol: '♐', dates: 'Nov 22 — Dec 21',
      sun: 'Core Self', sunMeta: 'Vision & Expansion', moon: 'Emotional', moonMeta: 'Restless Hope',
      pillars: ['Adventure', 'Wisdom', 'Optimism'] }
  ];

  var ENERGIES = [
    { title: 'Strong Intuition', text: 'Your intuition is particularly sharp today. The universe is speaking through subtle signs; trust these moments of insight.' },
    { title: 'Gentle Momentum', text: 'Progress arrives in quiet steps. Move with intention rather than urgency, and let clarity unfold naturally.' },
    { title: 'Inner Alignment', text: 'Mind and heart seek the same direction today. Pause before deciding, and choose what feels authentically yours.' },
    { title: 'Creative Spark', text: 'Inspiration circles close today. Capture the first idea that arrives — it carries more power than you expect.' },
    { title: 'Protective Calm', text: 'A steady energy surrounds you. Set gentle boundaries and preserve your focus for what truly matters.' },
    { title: 'Open Reception', text: 'You are especially receptive to guidance today. Notice repeating symbols, numbers, or conversations.' }
  ];

  var MOON_VARIANTS = [
    'Deep Reflection', 'Quiet Longing', 'Soft Courage', 'Healing Rest',
    'Emotional Clarity', 'Inner Listening', 'Tender Release', 'Sacred Pause'
  ];

  var MOON_META = {
    'Deep Reflection': 'Turn inward for clarity.',
    'Quiet Longing': 'Honor what your heart remembers.',
    'Soft Courage': 'Move forward with gentle strength.',
    'Healing Rest': 'Recovery is part of progress.',
    'Emotional Clarity': 'Feelings sharpen your perspective.',
    'Inner Listening': 'Silence reveals the next step.',
    'Tender Release': 'Let go with compassion.',
    'Sacred Pause': 'Stillness holds the answer.'
  };

  function hashSeed(str) {
    var h = 2166136261;
    for (var i = 0; i < str.length; i++) {
      h ^= str.charCodeAt(i);
      h = Math.imul(h, 16777619);
    }
    return h >>> 0;
  }

  function mulberry32(a) {
    return function () {
      a |= 0;
      a = (a + 0x6d2b79f5) | 0;
      var t = Math.imul(a ^ (a >>> 15), 1 | a);
      t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  }

  function pick(rng, arr) {
    return arr[Math.floor(rng() * arr.length)];
  }

  function getZodiacByDate(date) {
    var m = date.getMonth() + 1;
    var d = date.getDate();
    if ((m === 12 && d >= 22) || (m === 1 && d <= 19)) return ZODIACS[0];
    if ((m === 1 && d >= 20) || (m === 2 && d <= 18)) return ZODIACS[1];
    if ((m === 2 && d >= 19) || (m === 3 && d <= 20)) return ZODIACS[2];
    if ((m === 3 && d >= 21) || (m === 4 && d <= 19)) return ZODIACS[3];
    if ((m === 4 && d >= 20) || (m === 5 && d <= 20)) return ZODIACS[4];
    if ((m === 5 && d >= 21) || (m === 6 && d <= 20)) return ZODIACS[5];
    if ((m === 6 && d >= 21) || (m === 7 && d <= 22)) return ZODIACS[6];
    if ((m === 7 && d >= 23) || (m === 8 && d <= 22)) return ZODIACS[7];
    if ((m === 8 && d >= 23) || (m === 9 && d <= 22)) return ZODIACS[8];
    if ((m === 9 && d >= 23) || (m === 10 && d <= 22)) return ZODIACS[9];
    if ((m === 10 && d >= 23) || (m === 11 && d <= 21)) return ZODIACS[10];
    return ZODIACS[11];
  }

  function normalizeImageUrl(url) {
    if (!url) return '';
    if (url.indexOf('//') === 0) return 'https:' + url;
    return url;
  }

  function setText(id, value) {
    var el = document.getElementById(id);
    if (el) el.textContent = value;
  }

  function initScrollReveal() {
    var cards = document.querySelectorAll('.moyshop-horoscope__card');
    if (!('IntersectionObserver' in window)) {
      cards.forEach(function (c) { c.classList.add('is-visible'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) entry.target.classList.add('is-visible');
      });
    }, { threshold: 0.1 });
    cards.forEach(function (c) { observer.observe(c); });
    if (cards[0]) cards[0].classList.add('is-visible');
  }

  function init() {
    document.body.classList.add('moyshop-horoscope-page');

    var configEl = document.getElementById('moyshop-horoscope-config');
    if (!configEl) return;

    var config = JSON.parse(configEl.textContent);
    var products = config.products || [];

    var today = new Date();
    var seedKey = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
    var rng = mulberry32(hashSeed(seedKey));

    var sign = getZodiacByDate(today);
    var energy = pick(rng, ENERGIES);
    var moonVariant = pick(rng, MOON_VARIANTS);
    var product = products.length ? pick(rng, products) : null;

    setText('horoscope-sign-name', sign.name);
    setText('horoscope-sign-dates', sign.dates);

    var signIcon = document.getElementById('horoscope-sign-icon');
    if (signIcon) signIcon.textContent = sign.symbol;

    setText('horoscope-energy-title', energy.title);
    setText('horoscope-energy-text', energy.text);

    setText('horoscope-sun-value', sign.sun);
    setText('horoscope-sun-meta', sign.sunMeta);
    setText('horoscope-moon-value', sign.moon);
    setText('horoscope-moon-meta', moonVariant + ' · ' + (MOON_META[moonVariant] || ''));

    var pillarsEl = document.getElementById('horoscope-pillars');
    if (pillarsEl) {
      pillarsEl.innerHTML = sign.pillars.map(function (p) {
        return '<span class="moyshop-horoscope__tag">' + p + '</span>';
      }).join('');
    }

    var productLink = document.getElementById('horoscope-product-link');
    var productImg = document.getElementById('horoscope-product-img');
    var signIconEl = document.getElementById('horoscope-sign-icon');

    if (product) {
      if (productLink) productLink.href = product.url;
      var imgUrl = normalizeImageUrl(product.image);
      if (productImg && imgUrl) {
        productImg.src = imgUrl;
        productImg.alt = product.title;
        productImg.classList.remove('is-hidden');
        if (signIconEl) signIconEl.style.display = 'none';
      }
    } else if (productImg) {
      productImg.classList.add('is-hidden');
    }

    initScrollReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
